export default __webpack_public_path__ + "static/media/volumetric-weight-china.67c13691.png";